import { IGameEventPayload, IGameEventsRequestParams, IPlayerEventPayload, IPlayerEventsRequestParams, IPlayerShiftEventsRequestParams } from './event.models';

export class FetchGameEventDefinitions {
    public static readonly type = '[Event] FetchGameEventDefinitions';
}

export class FetchPlayerEventDefinitions {
    public static readonly type = '[Event] FetchPlayerEventDefinitions';
}

export class FetchShiftEventDefinitions {
    public static readonly type = '[Event] FetchShiftEventDefinitions';
}

export class FetchFlagDefinitions {
    public static readonly type = '[Event] FetchFlagDefinitions';
}

export class FetchGameEvents {
    public static readonly type = '[Event] FetchGameEvents';
    constructor(public readonly params: IGameEventsRequestParams) {}
}

export class FetchPlayerEvents {
    public static readonly type = '[Event] FetchPlayerEvents';
    constructor(public readonly params: IPlayerEventsRequestParams) {}
}

export class FetchPlayerShiftEvents {
    public static readonly type = '[Event] FetchPlayerShiftEvents';
    constructor(public readonly params: IPlayerShiftEventsRequestParams) {}
}

export class AddPlayerEvent {
    public static readonly type = '[Event] AddPlayerEvent';
    constructor(public readonly gameId: string, public readonly payload: IPlayerEventPayload) {}
}

export class AddGameEvent {
    public static readonly type = '[Event] AddGameEvent';
    constructor(public readonly gameId: string, public readonly payload: IGameEventPayload) {}
}

/** Deletes every selected event. State updates only after the whole delete succeeds. */
export class DeleteEvents {
    public static readonly type = '[Event] DeleteEvents';
    constructor(
        public readonly gameEventIds: readonly string[],
        public readonly playerEventIds: readonly string[],
        public readonly shiftEventIds: readonly string[]
    ) {}
}
